import usePlaywireRamp from '@src/hooks/usePlaywireRamp';

export function triggerPageViewAds(debugKey, videoAdType?: 'corner_ad_video' | 'precontent_ad_video') {
    if (!window.ramp || !window.ramp.que) return;
    const ads = [
        { type: 'left_rail' },
        { type: 'right_rail' },
        ...(videoAdType ? [{ type: videoAdType }] : []),
        // {
        //     type: 'leaderboard_btf',
        //     selectorId: 'yourUniqueId', // Replace with your actual selector ID
        // },
    ];

    const payload = {
        ads,
        path: location.pathname,
        countPageView: true,
    };

    console.log(`[PlaywireRamp] Triggering spaAds from ${debugKey}:`, payload);

    window.ramp.que?.push(() => {
        window.ramp.spaAds(payload);
    });
}

const PlaywireRamp = () => {
    const { isLoaded } = usePlaywireRamp();

    return null;
};

export default PlaywireRamp;
